export default __webpack_public_path__ + "static/media/34.dc214c8a.png";